import { all, takeLatest, put, call } from 'redux-saga/effects';
import { getEmailIdByToken, getRewardProfile } from 'yoda-interfaces/lib/Account/AccountApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import * as GroupActionTypes from 'yoda-account-components/lib/actionTypes/GroupActionTypes';

export function* getEmailByToken(action) {
    try {
        const response = yield call(getEmailIdByToken, action.payload);
        const payload = {
            response: response.data || response.response.data,
        };
        if (response.status === 200) {
            payload.isSuccess = true;
            yield all([put({ type: GroupActionTypes.GET_EMAILID_BY_TOKEN_SUCCESS, payload })]);
        } else {
            yield put({
                type: GroupActionTypes.GET_EMAILID_BY_TOKEN_ERROR,
                payload: { isSuccess: false, error: response.response.data },
            });
        }
    } catch (error) {
        yield put({
            type: GroupActionTypes.GET_EMAILID_BY_TOKEN_ERROR,
            payload: {
                isSuccess: false,
                error,
            },
        });
    }
}

export function* getRewardProf(action) {
    try {
        const response = yield call(FactorySaga, getRewardProfile, action);
        const payload = {
            response: response.data || response.response.data,
        };
        if (response.isSuccess) {
            payload.isSuccess = true;
            yield all([put({ type: GroupActionTypes.GET_REWARDS_PROFILE_SUCCESS, payload })]);
        } else {
            payload.isSuccess = false;
            yield put({
                type: GroupActionTypes.GET_REWARDS_PROFILE_ERROR,
                payload,
            });
        }
    } catch (error) {
        yield put({
            type: GroupActionTypes.GET_REWARDS_PROFILE_ERROR,
            payload: {
                isSuccess: false,
                error,
            },
        });
    }
}

function* watchGroupSaga() {
    yield takeLatest(GroupActionTypes.GET_EMAILID_BY_TOKEN, getEmailByToken);
    yield takeLatest(GroupActionTypes.GET_REWARDS_PROFILE, getRewardProf);
}

watchGroupSaga.sagaName = 'groupSaga';
export default watchGroupSaga;
